import { useState } from 'react';
import { message } from 'antd';
import { useTranslate } from '@tolgee/react';
import { overseaTranslate } from 'services/api/overseaTranslate';
import { useMemoizedFn } from 'ahooks';
import useCurrentChat from 'hooks/business/im/useCurrentChat';
import posthog from '@leyan/lytics';

/**
 * 消息编辑器翻译
 * 单一职责：当前输入内容的翻译请求与 loading 状态
 */
export function useMessageEditorTranslate(
  conversationId: string,
  input: string,
  targetLang: General.Language,
  region: Conversation.Conversation['region'],
  setInput: (conversationId: string, value: string) => void,
) {
  const { t } = useTranslate();
  const [translating, setTranslating] = useState(false);

  const handleTranslateClick = useMemoizedFn(async () => {
    setTranslating(true);
    try {
      await overseaTranslate(input, targetLang, 'messageEditor', region).then((resp) => {
        setInput(conversationId, resp as unknown as string);
      });
    } catch (e) {
      message.error(t('scene.chatWorkspace.messageEditor.translation.failed'));
    }
    setTranslating(false);
  });

  return {
    handleTranslateClick,
    translating,
  };
}

export function useMessageEditorTranslateButtonChange(
  conversationId: Conversation.Conversation['conversationId'],
  region: Conversation.Conversation['region'],
) {
  const { setPreference } = useCurrentChat();

  const onChange = useMemoizedFn((lang: General.Language) => {
    posthog.capture('$changePrefLang', {
      region,
      lang,
      conversationId,
    });

    setPreference({
      buyerLang: lang,
    });
  });

  return { onChange };
}
